import React from "react";
import PT from "prop-types";
import * as S from "./styled";
import TextInput from "_c/form/TextInput";
import Select from "_c/Select";
import { ORDERS_NS } from "@/i18n/ns";
import TextSearch from "../";

const MobileTextSearch = (props) => {
  return (
    <TextSearch updateQuery={props.updateQuery} query={props.query} t={props.t}>
      {({
        search,
        searchBy,
        changeSearch,
        changeSearchBy,
        searchOptions,
        reset,
      }) => (
        <S.Wrap
          key="mobile-search"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.95 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <S.Inputs>
            <TextInput
              value={search}
              onChange={changeSearch}
              style={{ marginBottom: "10px" }}
              placeholder={props.t(`${ORDERS_NS}:search.text.query_label`)}
            />
            <Select
              value={searchBy}
              onChange={changeSearchBy}
              options={searchOptions}
              menuPlacement="top"
              placeholder={props.t(`${ORDERS_NS}:search.text.type_label`)}
              isClearable
              isSearchable={false}
            />
          </S.Inputs>
          <S.ResetButton onClick={reset}>
            {props.t("common:reset")}
          </S.ResetButton>
        </S.Wrap>
      )}
    </TextSearch>
  );
};
MobileTextSearch.propTypes = {
  query: PT.object.isRequired,

  updateQuery: PT.func.isRequired,
  t: PT.func.isRequired,
};
export default MobileTextSearch;
